import React, { useState,useContext } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { Button, Dialog, Grid, makeStyles, Popover, TextField, Checkbox, FormControlLabel, RadioGroup, Radio, FormHelperText } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService';
import { useLocation } from 'react-router-dom';
import {ModificationContextStore} from '../../../../context/ModificationContext'
import { awaitWithLoading, billingPeriodPretty, liabilityLimitPretty } from '../../../../services/utils'
import { ReactComponent as AddSvg } from '../../../../assets/add.svg';
import { CustomizeHullSection } from '../../../Insurance/CustomizePolicySections/CustomizeHullSection';
import { Controller, useForm } from 'react-hook-form';
import { ImageDropzone } from '../../../Core/Dropzone/ImageDropzone';
import './CustomizeDroneModify.scss';
import { format } from 'date-fns/esm';
import { HullApi } from '../../../../api/hull.api';
import { useStyles } from '@material-ui/pickers/views/Calendar/SlideTransition';
import {HULL_MAX_LENGTH_SERIAL_NUMBER, HULL_MIN_LENGTH_SERIAL_NUMBER } from '../../../../Constants';
import { SessionService } from '../../../../services/SessionService';
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService';
import { InsuranceBillingPeriod } from '../../../../models/insurance-models/InsuranceBillingPeriodModel';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import { de } from 'date-fns/locale';
import { DroneModel } from '../../../../models/insurance-models/InsuranceOptionModel';
import dayjs from 'dayjs';
import { SessionContextStore } from '../../../../context/SessionContext';
import { IsCommercialPopup } from '../../../PopUps/IsCommercialPopup';
import { set } from 'lodash';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import NewFillButton from '../../../Core/NewFillButton';
import NewButtonPopup from '../../../Core/Buttons/NewButtonPopup';






interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}


export const CustomizeDroneModify = ({endDate, defaultValues, mode, showFields,isRenewal}) => {
    const location = useLocation()
    const { register, triggerValidation, watch, setValue, errors, control, getValues, reset } = useForm({ mode: 'onChange', defaultValues})
    const [hasImage, setHasImage] = useState(defaultValues.drone_image_id)
    const changeDroneImage = () => setHasImage(false)
    const modificationContext = React.useContext(ModificationContextStore)
    const maximumDroneValue = SessionService.isAdmin() ? FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_DRONE_VALUE_FOR_ADMIN) : (SessionService.isBroker()? FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_DRONE_VALUE_FOR_BROKER) : FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_DRONE_VALUE))
    const sessionContext = React.useContext(SessionContextStore)

    const dateRange ={
        startDate: new Date(),
        endDate: endDate,
        key: 'selection'
    };
    const [isChecked, setIsChecked] = useState(false);


    React.useEffect(() => {
        if (mode.add){
            reset({make:'', model:'', serial:'', value:'', drone_image_id:'', id:'', start_date: dateRange.startDate, end_date: new Date().setDate(new Date().getDate() + 30)})
        }
        if (mode.modify){
            const endDate = !!defaultValues.end_date? new Date(defaultValues.end_date): null
            const startDate = !!defaultValues.start_date? new Date(defaultValues.start_date) : new Date(dateRange.startDate)
            const rpac = sessionContext.user.commercial
            reset({make: defaultValues.make, model: defaultValues.model, serial: defaultValues.serial, value: defaultValues.value, drone_image_id:defaultValues.drone_image_id, id: defaultValues.id ,start_date: startDate ,end_date: endDate, rpac })
            if(!!defaultValues.end_date){
                setIsChecked(true)
            }
        }
    }, [mode])

    React.useEffect(() => {
        register({ name: 'drone_image_id'})
        register({ name: 'id'})
    }, [])


    const onDroneImageDrop = async (files) => {
        let res = await awaitWithLoading(HullApi.uploadDroneImage(files[0]))
        if(!res.ok && res.status === 415) {
            EventEmitterService.dispatch(EventKey.ShowMessageBox, {title: "Unsupported file type!", body: "Please choose a different file"})
            return;
        }
        const {drone_image_id} = res.data;
        if(drone_image_id) {
            setValue('drone_image_id', drone_image_id)
            setHasImage(true)
        }
        else {
          EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
      };

    const onSubmit = async () => {
        let valid = await triggerValidation()
        if(valid) {
            const hull = getValues();
            const data = {... hull}
            const startDate = hull.start_date ? new Date(hull.start_date).toUTCString() : new Date().toUTCString()
            const endDate = hull.end_date ? new Date(hull.end_date).toUTCString() : null
            data.start_date = startDate 
            data.end_date = endDate
            data.deductibleRate = parseInt(defaultValues.deductibleRate)
            if(data.rpac) {
                if(data.isRenewal) {
                    modificationContext.setCommercialSubscription(true)
                } else {
                    modificationContext.setCommercialInsurance(true)
                }
            }
            if (mode.modify){
                if (mode.isDroneSetMode){
                    modificationContext.editDrone(data, mode.index,isRenewal)
                } else{
                    modificationContext.editEquipment(data, mode.index,isRenewal)
                }
            }

            if (mode.add){
                if (mode.isDroneSetMode){
                    modificationContext.addDrone(data, mode.index,isRenewal)
                } else{
                        modificationContext.addEquipment(data, mode.index,isRenewal)
                }
            }

            showFields()
        }
    }

    return (
    <React.Fragment>
        <Grid container xs={12} md={12} spacing={2}>
            <Grid item xs={12} md={6}>
                <TextField size="small" fullWidth variant="outlined"  className={`modify-hull lightgrayblue ${isMobile ? `text-tiny` : `text-small`}`} label="Make" type="text" name="make" inputRef={register({required: true})} helperText={errors.make ? 'Make is required' : 'e.g: DJI'} error={!!errors.make} />
            </Grid>
                <Grid item xs={6} md={3}>
            <TextField size="small" fullWidth variant="outlined" label="Model" type="text" name="model" inputRef={register({required: true})}  helperText={!!errors.model && 'Required'} error={!!errors.model} />
                </Grid>
            <Grid item xs={6} md={3}>
                <TextField size="small" fullWidth variant="outlined" label="Serial number" type="text" name="serial" inputRef={register({required: true, minLength: HULL_MIN_LENGTH_SERIAL_NUMBER, maxLength: HULL_MAX_LENGTH_SERIAL_NUMBER})} helperText={errors.serial && `Serial must be between ${HULL_MIN_LENGTH_SERIAL_NUMBER} - ${HULL_MAX_LENGTH_SERIAL_NUMBER} characters`} error={!!errors.serial} />
            </Grid>
            <Grid item xs={12} md={3}>
                <TextField size="small" fullWidth variant="outlined" label={`Value ${isMobile ? `` : `($0-$${maximumDroneValue.toLocaleString()})`}`} type="number" name="value" inputRef={register({required: true, min: FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_DRONE_VALUE), max: maximumDroneValue})}  helperText={errors.value && `Value must be between ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_DRONE_VALUE)} - ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${maximumDroneValue.toLocaleString()}`} error={!!errors.value}/>
            </Grid>
            <Grid item xs={12} md={6}>
                  <ImageDropzone isModifyFlow={true} onDrop={onDroneImageDrop} changeImage={changeDroneImage} hasImage={hasImage}/>
            </Grid>
            <Grid item xs={12} md={3}>
                <Button className={`${isMobile ? `margin-top-small` : ``} fullwidth add-hull bold textcenter`} onClick={onSubmit} color="primary">
                    {`${mode.modify ? `Update` : `Add hull`}`}
                </Button>
            </Grid>
            <Grid item xs={12}>

            </Grid>
        {
            !isRenewal && (!mode.modify || (defaultValues.end_date !== undefined && defaultValues.end_date !== null)) && modificationContext.subscription.billingPeriod ==  InsuranceBillingPeriod.YEAR && SessionService.isAdmin() && (
            <><Grid item xs={6} md={3}>
                            <FormControlLabel

                                control={<Checkbox
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}
                                    color="primary" />}
                                label="Specific Dates"
                                labelPlacement="start" />
                        </Grid><Grid container spacing={2} item xs={12} md={9}>
                                {isChecked && (
                                    <><Grid item xs={6} md={3}>
                                    <Controller className="margin-top-basic"
                                    control={control}
                                    name="start_date"
                                    as={
                                        <DatePicker
                                            fullWidth
                                            label="Start Date"
                                            variant="dialog"
                                            direction="horizontal"
                                            inputVariant='outlined'
                                            disablePast
                                            format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                                            maxDate={dateRange.endDate} 
                                        />}
                                    />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <Controller className="margin-top-basic"
                                        control={control}
                                        name="end_date"
                                        as={
                                            <DatePicker
                                                fullWidth
                                                inputVariant='outlined'
                                                label="End Date"
                                                variant="outlined"
                                                direction="horizontal" 
                                                disablePast
                                                format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
                                                maxDate={dateRange.endDate} 
                                                minDate={watch('start_date')}
                                            />}
                                        />
                                    </Grid></>)}
                            </Grid></>
            )
        }
        
        </Grid>
    
                
    </React.Fragment>)
}